// Messages for portal/Sessions (auto-merged into the i18n catalog by lib/i18n.ts).
export const en = {
  'portal.sessions.head': 'Sessions — Customer portal',
  'portal.sessions.title': 'Active sessions',
  'portal.sessions.intro': 'Devices currently signed in to your account.',
  'portal.sessions.unknown_device': 'Unknown device',
  'portal.sessions.this_session': '· this session',
  'portal.sessions.unknown_ip': 'unknown IP',
  'portal.sessions.last_active': 'last active {time}',
  'portal.sessions.sign_out': 'Sign out',
  'portal.sessions.revoke': 'Revoke',
}

export const zhTW = {
  'portal.sessions.head': '工作階段 — 客戶入口',
  'portal.sessions.title': '使用中的工作階段',
  'portal.sessions.intro': '目前登入您帳戶的裝置。',
  'portal.sessions.unknown_device': '未知裝置',
  'portal.sessions.this_session': '· 此工作階段',
  'portal.sessions.unknown_ip': '未知 IP',
  'portal.sessions.last_active': '上次活躍 {time}',
  'portal.sessions.sign_out': '登出',
  'portal.sessions.revoke': '撤銷',
}
